import {
  AbstractControl,
  NgControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export function getValidationTranslation(
  translateService: TranslateService,
  errors: ValidationErrors | undefined | null,
): string | null {
  if (errors === undefined || errors === null) return null;
  const error = Object.keys(errors)[0];
  switch (error) {
    case 'required':
      return translateService.instant('validation.required');
    case 'minlength':
      return translateService.instant('validation.minLength', {
        minLength: Object.values(errors)[0].requiredLength,
      });
    default:
      return null;
  }
}

export function hasValidationError(
  control: NgControl | undefined,
): boolean | null {
  return !!control?.invalid && (control?.touched || control?.dirty);
}

export function simplePhoneValidator(): ValidatorFn {
  const pattern = /^[+]?[\d\s\-()]{7,20}$/;
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').trim();
    if (!value) return null;
    return pattern.test(value) ? null : { phoneInvalid: true };
  };
}
